import React from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useParceiroAuth } from '../contexts/ParceiroAuthContext';
import { Home, ClipboardList, PlusCircle, Building2, Receipt, UserCircle, LogOut } from 'lucide-react';

const navItems = [
  { path: '/parceiro/dashboard', label: 'Início', icon: Home },
  { path: '/parceiro/solicitacoes', label: 'Solicitações', icon: ClipboardList },
  { path: '/parceiro/nova-solicitacao', label: 'Solicitar', icon: PlusCircle, destaque: true },
  { path: '/parceiro/imoveis', label: 'Imóveis', icon: Building2 },
  { path: '/parceiro/faturas', label: 'Faturas', icon: Receipt },
];

const ParceiroLayout = ({ children }) => {
  const { parceiro, logout } = useParceiroAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F4F6F5] pb-20 md:pb-0">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-[#3D4F5F] text-white shadow-md">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/parceiro/dashboard" className="flex items-center gap-2">
            <img src="/logo-full.png" alt="Tenance" className="h-8 brightness-0 invert" />
            <span className="text-xs bg-[#2B7A3D] px-2 py-0.5 rounded-full font-semibold tracking-wide">PARCEIRO</span>
          </Link>
          <div className="flex items-center gap-1">
            <span className="hidden sm:block text-sm text-gray-200 mr-2 truncate max-w-[180px]" data-testid="parceiro-nome-header">
              {parceiro?.nome}
            </span>
            <button onClick={() => navigate('/parceiro/perfil')} className="p-2 rounded-lg hover:bg-white/10" data-testid="parceiro-perfil-btn" title="Perfil">
              <UserCircle size={22} />
            </button>
            <button onClick={logout} className="p-2 rounded-lg hover:bg-white/10" data-testid="parceiro-logout-btn" title="Sair">
              <LogOut size={20} />
            </button>
          </div>
        </div>
        {/* Desktop nav */}
        <nav className="hidden md:block bg-[#34434F]">
          <div className="max-w-5xl mx-auto px-4 flex gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`pnav-${item.path.split('/').pop()}`}
                className={({ isActive }) =>
                  `px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                    isActive ? 'border-[#4CAF50] text-white' : 'border-transparent text-gray-300 hover:text-white'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-5">{children}</main>

      {/* Bottom nav (mobile) */}
      <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 md:hidden">
        <div className="grid grid-cols-5">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`pnav-mobile-${item.path.split('/').pop()}`}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center py-2 text-[10px] font-medium ${
                    item.destaque ? 'text-[#2B7A3D]' : isActive ? 'text-[#2B7A3D]' : 'text-gray-500'
                  }`
                }
              >
                <Icon size={item.destaque ? 30 : 22} strokeWidth={item.destaque ? 2.2 : 2} />
                <span className="mt-0.5">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default ParceiroLayout;
